module.exports = __webpack_public_path__ + "img/icon-comment.22ffd1d0.svg";